import { useParams } from "react-router-dom"

import { PropTypes } from "@l2r-front/l2r-proptypes"
import { formatNumber } from "@l2r-front/l2r-utils"

import { DOCUMENTS_COUNT_PER_PAGE } from "../../constants/pages"
import { useDocumentStateContext } from "../../contexts/DocumentContext"
import { useDocuments } from "../../hooks/queries/useDocument"

import * as Styled from "./DocumentsCountBadge.styled"

export function DocumentsCountBadge(props) {

    const {
        className,
    } = props

    const { road } = useParams()
    const { apiFilters } = useDocumentStateContext()

    const { data, isLoading, isError } = useDocuments({
        ...(road && { linear_location_road: road }),
        limit: DOCUMENTS_COUNT_PER_PAGE,
        ...(apiFilters && { ...apiFilters }),
    })

    if (isLoading) {
        return <Styled.DocumentsCountBadgeSkeleton className={className} />
    }

    if (isError || !data) {
        return null
    }

    return <Styled.Wrapper className={className}>
        <Styled.Text variant="Desktop & Mobile/Body/Regular">{formatNumber(data.count)}</Styled.Text>
    </Styled.Wrapper>
}

DocumentsCountBadge.propTypes = {
    className: PropTypes.string,
}